import apiPathname from '../json/apiPathname.json'

let urlMap = {}
urlMap.local = location.origin;

export function setUrlMap (urlMapObj) {
  Object.assign(urlMap, apiPathname, urlMapObj);
}

export function getApiUrlString (key, query = '') {
  const pathname = apiPathname[key];
  const queryString = /^\?/.test(query)
    ? query
    : `${(query ? '?' : '')}${query}`;

  return `${urlMap.apiOrigin}/mt/datas/${pathname}${queryString}`;
}

export function getFeatureUrlString (id) {
  return `${urlMap.local}${urlMap.feature}${id}.json`
}
